import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const DiscountAdd = () => {
  const navigate = useNavigate();
  const initialFormState = {
    disc_name: "",
    disc_amount: "",
    disc_start_date: "",
    disc_end_date: "",
    status: "",
  };

  const [DiscountUser, setDiscountUser] = useState(initialFormState);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setDiscountUser({ ...DiscountUser, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_Discount",
        DiscountUser
      );

     if (response.data.status === true) {
  toast.success(response.data.message || "Discount added successfully!");
  navigate("/discount-list");
} else {
  toast.error(response.data.error || "Failed to add data");
}

    } catch (error) {
      console.error("API Error:", error.response || error.message);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Discount Add</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Discount</a>
                </li>
                <li className="breadcrumb-item active">Discount Add</li>
              </ol>
            </div>
          </div>
        </div>
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Add New Discount</h4>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="card">
          <div className="card-body">
            <form onSubmit={submitForm} className="row">
              <div className="mb-3 col-lg-6">
                <label className="form-label">Discount Name</label>
                <input
                  type="text"
                  name="disc_name"
                  id="disc_name"
                  className="form-control"
                  placeholder="Enter discount name"
                  required
                  value={DiscountUser.disc_name}
                  onChange={handleInput}
                />
              </div>

              <div className="mb-3 col-lg-6">
                <label className="form-label">Percentage (%)</label>
                <input
                  type="number"
                  name="disc_amount"
                  id="disc_amount"
                  className="form-control"
                  placeholder="Enter discount percentage"
                  required
                  min={1}
                  max={100}
                  value={DiscountUser.disc_amount}
                  onChange={handleInput}
                />
              </div>

              <div className="mb-3 col-lg-6 ">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  name="disc_start_date"
                  id="disc_start_date"
                  className="form-control"
                  required
                  value={DiscountUser.disc_start_date}
                  onChange={handleInput}
                />
              </div>

              <div className="mb-3 col-lg-6">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  name="disc_end_date"
                  id="disc_end_date"
                  className="form-control"
                  required
                  value={DiscountUser.disc_end_date}
                  onChange={handleInput}
                />
              </div>

              <div className="mb-3 col-lg-6">
                <label className="form-label">Status</label>
                <select
                  name="status"
                  className="form-select"
                  value={DiscountUser.status}
                  onChange={handleInput}
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
              <div className="p-3  mb-3 rounded">
                <div className="row justify-content-end g-2">
                  <div className="col-lg-2">
                    <button type="submit" className="btn btn-outline-secondary w-100">
                      Save Change
                    </button>
                  </div>
                  <div className="col-lg-2">
                    <Link to="/discount-list" className="btn btn-primary w-100">
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountAdd;
